import get from 'lodash.get'

class FactsheetValidator {

  static REGEX_TYPE_INTEGER = /^(0|[-+]?[1-9]\d*)$/
  static REGEX_TYPE_NUMBER = /^(\d+\.?\d*|\.\d+)$/

  // numbers can be of format .01 as well

  constructor () {
    this.regexes = {}
  }

  validateValue (attributeValue, attributeDefinition) {
    const type = get(attributeDefinition, 'value.type', null)
    switch (type) {
      case 'INTEGER':
        return this.getRegexObj(FactsheetValidator.REGEX_TYPE_INTEGER).test(attributeValue)
      case 'NUMBER':
        return this.getRegexObj(FactsheetValidator.REGEX_TYPE_NUMBER).test(attributeValue)
      case 'URL':
        return this.validateUrlValue(attributeValue) !== false
      case 'PRICE':
        return this.validatePriceValue(attributeValue) !== false
      default:
        return true
    }
  }

  validateUrlValue (attributeValue) {
    if (!attributeValue.startsWith('https://')) {
      return false
    }
    try {
      return new URL(attributeValue)
    } catch (e) {
      return false
    }
  }

  getRegexObj (regex) {
    if (!this.regexes.hasOwnProperty(regex)) {
      this.regexes[regex] = new RegExp(regex)
    }
    return this.regexes[regex]
  }

  validatePriceValue (attributeValue) {
    return this.getRegexObj(FactsheetValidator.REGEX_TYPE_NUMBER).test(attributeValue)
      && parseFloat(attributeValue) >= 0.1
  }
}

export const factsheetValidator = new FactsheetValidator()
